import React from 'react';
import { Select } from 'antd';
import moment from 'moment-timezone';

const TimeZone = ({ value, onChange, disabled, props }) => (
  <Select
    {...props}
    getPopupContainer={trigger => trigger.parentNode}
    id="timeZone"
    showSearch
    value={value}
    onChange={onChange}
    disabled={disabled}
  >
    {moment.tz.names().map(tz => (
      <Select.Option key={tz} value={tz}>
        {tz} - <em>GMT {moment.tz(tz).format('Z')}</em>
      </Select.Option>
    ))}
  </Select>
);

export default TimeZone;
